import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTeamDashboard = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 24,
	viewBox: "0 -960 960 960",
	width: 24,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M212.309-140.001q-29.923 0-51.115-21.193-21.193-21.192-21.193-51.115v-535.382q0-29.923 21.193-51.115 21.192-21.193 51.115-21.193h535.382q29.923 0 51.115 21.193 21.193 21.192 21.193 51.115v535.382q0 29.923-21.193 51.115-21.192 21.193-51.115 21.193H212.309ZM410.001-200v-250.001H200v237.692q0 5.385 3.462 8.847 3.462 3.462 8.847 3.462h197.692Zm59.998 0h277.692q5.385 0 8.847-3.462 3.462-3.462 3.462-8.847v-237.692H469.999V-200ZM200-509.999h560v-237.692q0-5.385-3.462-8.847-3.462-3.462-8.847-3.462H212.309q-5.385 0-8.847 3.462-3.462 3.462-3.462 8.847v237.692Z" })
});
export default SvgTeamDashboard;
